import { gql } from "@apollo/client";

export const EDIT_CAMPAIGN_CELLER_MESSAGING = gql`
  mutation campaignEditCallerMessaging(
    $campaignId: ID!
    $customCallerAlert: CustomCallerAlertInput!
    $customEndCard: CustomEndMessageInput!
  ) {
    campaignEditCallerMessaging(
      id: $campaignId
      customCallerAlert: $customCallerAlert
      customEndCard: $customEndCard
    ) {
      id
      customCallerAlert {
        expiredAt
        message
      }
      customEndCard {
        onCompleteMessage
        onPausedMessage
        onOutOfHoursMessage
      }
      onCompleteMessage
      onPausedMessage
      outOfHoursMessage
    }
  }
`;
